import { FC } from 'react';
import { PrismicRichText } from '@prismicio/react';
import { ModalBodyContentProps } from '@/types';
import { ModalSliceCreditAuthorizationPrimary } from '../../../../../prismicio-types';

export const CreditAuthorization: FC<
  ModalBodyContentProps<ModalSliceCreditAuthorizationPrimary>
> = ({ data, styles, components }) => {
  return (
    <div className={styles.authWrapper}>
      {data.infolist.map((item, index) => (
        <div key={`${item.title[0]?.type}-${index}`}>
          <PrismicRichText field={item.title} components={components} />
          <PrismicRichText field={item.description} components={components} />
        </div>
      ))}
    </div>
  );
};
